/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header } from './layouts';
import { slider, tabs, accordion, pageAnim, inputs, StackAnim, counter, SvgMap, popup,/*  GoogleMap */ } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  StackAnim.init();
  pageAnim.init();
  inputs.init();
  counter.init();
  popup.init();
  
  // SVG Haritası - otomatik olarak başlatılır
  // SvgMap.init(); // Bu satırı kaldırdık çünkü SvgMap constructor'da otomatik başlar
  
  // Page Modules
  // Basit Google Map init (otomatik konteyner ve key içeride)
  /* GoogleMap.init(); */
}());
